"use client";

import Link from "next/link";
import React, { useEffect, useState } from "react";
import NavDropDown from "./nav-dropdown";
import SignInPopup from "../signin-popup";
import useAuthStore from "@/lib/useAuthStore";
import { ChevronDown, Plane } from "lucide-react";
import { School } from "lucide-react";
import MenuBar from "./menubar";
import { usePathname } from "next/navigation";
import WebLogo from "@/components/common/WebLogo";
import useHotelBookingStore from "@/lib/useHotelBookingStore";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { formatToRupee } from "@/lib/internalApis";
import TJApiBalance from "@/components/layout/apiBalance";
import WalletCreditInfo from '@/components/layout/WalletCreditInfo';



const Navbar = () => {
  const { isAuthenticated, getUser,user ,logOutUser}: any = useAuthStore();
  const { isErrors }: any = useHotelBookingStore()
  const pathname = usePathname();

  console.log("user",user)
  useEffect(() => {
    getUser();
  }, []);

  return (
    <>
      <div className="bg-white opacity-100">
        <nav className="flex items-center py-3 px-2 gap-4 container mx-auto ">
          {/* shadow-sm */}
          <div className="flex-1 flex items-center basis-[70%] md:basis-[35%] md:gap-8 ">
            <div className="block md:hidden mr-5">
              <MenuBar />
            </div>

            <div>
              <Link href="#" className="text-white hover:text-gray-300">
                <WebLogo />
              </Link>
            </div>
            <div className="hidden md:block basis-30">
              <div className="flex justify-between items-center w-full text-[16px] text-secondary font-bold gap-3">
                <Link href="/flight">
                  <span
                    className={`${pathname === "/flight" ? "text-primary" : "text-secondary"
                      } flex justify-between items-center`}
                  >
                    <Plane className="mr-2 w-[15px]" />
                    Flight
                  </span>
                </Link>
                <Link href="/hotel">
                  {" "}
                  <span
                    className={`${pathname === "/" ? "text-primary" : "text-secondary"
                      } flex justify-between items-center`}
                  >
                    <School className="mr-2 w-[15px]" />
                    Hotel
                  </span>{" "}
                </Link>
              </div>
            </div>
          </div>
          <div className="hidden md:block"> 
          {(user?.role_type === "NORMAL_USER" || user?.role_type === "CORPORATE_ADMIN") && (
            <WalletCreditInfo 
              walletBalance={user?.wallet_balance} 
              walletLimit={user?.wallet_limit}
              availableCredit={user?.available_credit}
            />
          )}
          </div>
          <div className="hidden md:block">
            <TJApiBalance/>
          {(user?.settings?.CORPORATE_ADMIN || user?.settings?.NORMAL_USER || user?.settings?.CORPORATE_USER) && (user?.settings?.CORPORATE_ADMIN?.relationShipManager?.name || user?.settings?.NORMAL_USER?.relationShipManager?.name || user?.settings?.CORPORATE_USER?.relationShipManager?.name) && <div >
            <HoverCard openDelay={100}>
              <HoverCardTrigger asChild>
                <div className="text-[#084A76] text-[14px] py-1 px-2 hover:cursor-pointer">
                  <span>Your TravelFirst Guide</span>
                </div>
              </HoverCardTrigger>
              <HoverCardContent className="w-[400px] mr-10">
                <div className="rounded-md w-full bg-white">
                  <Table>
                    <TableHeader>
                      <TableRow className="bg-[#084A76]">
                        <TableHead className="!text-[10px] !font-semibold !text-white text-center">NAME</TableHead>
                        <TableHead className="!text-[10px] !font-semibold !text-white text-center">MOBILE</TableHead>
                        <TableHead className="!text-[10px] !font-semibold !text-white text-center">EMAIL</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      <TableRow className="!text-[12px] bg-muted/100 text-black font-light">
                        <TableCell className="text-center">
                          {(user?.settings?.CORPORATE_ADMIN?.relationShipManager?.name || user?.settings?.NORMAL_USER?.relationShipManager?.name || user?.settings?.CORPORATE_USER?.relationShipManager?.name)}
                        </TableCell>
                        <TableCell className="text-center">
                          {(user?.settings?.CORPORATE_ADMIN?.relationShipManager?.mobile || user?.settings?.NORMAL_USER?.relationShipManager?.mobile || user?.settings?.CORPORATE_USER?.relationShipManager?.mobile) || "-"}
                        </TableCell>
                        <TableCell className="text-center">
                          {(user?.settings?.CORPORATE_ADMIN?.relationShipManager?.email || user?.settings?.NORMAL_USER?.relationShipManager?.email || user?.settings?.CORPORATE_USER?.relationShipManager?.email)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </HoverCardContent>
            </HoverCard>
          </div>}
          </div>
          
          <div className="flex items-center juestify-end space-x-4">
            <div className="relative">
             <span className="flex items-center gap-2 cursor-pointer">
             <NavDropDown/>
             </span>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;